import api from "../configurations/http-common";

export const getDashboardData = async (params) => {
  return api.securedAxios().get("/web/dashboard", {
    params,
  });
};
